<template>
    <div class="d-flex flex-column w-100">
        <nav-bar/>
        <banner titulo="Agendamento de Exames" subTitulo="Agende os exames dos seus funcionários com a primeseg"/>
        <div class="borda d-flex flex-column w-75 mx-auto justify-content-start p-3 gap-md">
			<div class="d-flex">
				<b-button variant="outline-success" @click="$bvModal.show('modal-agendar-horario')">Agendar Horário</b-button>
				<modal-agendar-horario @success="agendamentoCriadoComSucesso()"/>
			</div>
			<div v-if="!existeAgendamentoCriado" class="py-5 d-flex flex-row justify-content-center align-items-center" style="background-color: hsl(0, 0%, 50%, 0.2);border-radius: 10px;">
				<span style="color: gray; font-size: 18px;">
					Ainda não há agendamentos
				</span>
			</div>
			<TableAgendamentosUsuario v-else ref="tableAgendamento" />
			<b-modal id="sucesso-agendamento"  size="md" hide-footer centered title="Agendamento Realizado Com Sucesso">
				<p>A solicitação de agendamento será analisada e em breve retornaremos o horário e dia do atendimento. Acompanhe as informações pela página <strong>Agendamento.</strong></p>
				<div class="d-flex justify-content-center">
					<b-button @click="$bvModal.hide('sucesso-agendamento')" variant="outline-success">OK</b-button>
				</div>
			</b-modal>
		</div>
    </div>
</template>

<script>
import NavBar from "../../components/shared/NavBar.vue";
import Banner from "../../components/shared/Banner.vue";
import ModalAgendarHorario from "../../components/Agendamento/ModalAgendarHorario.vue";
import AgendamentoService from "../../service/AgendamentoService.js";
import TableAgendamentosUsuario from "../../components/Agendamento/TableAgendamentosUsuario.vue";

export default {
	components: { NavBar, Banner, ModalAgendarHorario, TableAgendamentosUsuario },
	name: "AgendamentoCliente",
 		data() {
		return {
			existeAgendamentoCriado: true,
		};
	},
	created() {
		this.verificaSeHaAlgumAgendamentoCriado();
	},
	methods: {
		async verificaSeHaAlgumAgendamentoCriado() {
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			AgendamentoService.verificaSeHaAlgumAgendamentoCriado(usuarioLogado.id)
				.then((res) => {
					this.existeAgendamentoCriado = res.data;
				}).catch(() => {
					this.mensagem("Não foi possível consultar os agendamentos nesse momento", "Aviso", "danger");
				});
		},
		async agendamentoCriadoComSucesso() {
			await this.verificaSeHaAlgumAgendamentoCriado();
			if (!this.$refs.tableAgendamento) {
				this.$bvModal.show("sucesso-agendamento");
				return;
			}
			this.$refs.tableAgendamento.consultarPorUsuario();
			this.$bvModal.show("sucesso-agendamento");
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/agendamento/AgendamentoCliente.vue